import { FSA } from '@typings/redux';
import { fork, ForkEffect, put, select, takeLatest } from 'redux-saga/effects';
import { Action } from 'redux';
import { UserActionType } from 'store/user/user.actionTypes';
import { fetchUserPermission } from 'store/user/user.action';
import { fetchAccessRules } from 'store/accessRules';
import { userId } from 'store/user';

export function* userInfoSuccess(action: FSA): IterableIterator<any> {
  // After user info is loaded, fetch user permissions
  const userIdValue = yield select(userId);
  if (userIdValue) {
    yield put(fetchUserPermission(userIdValue) as unknown as Action);
    yield put(fetchAccessRules() as unknown as Action);
  }
}

export function* userSaga(): Iterator<ForkEffect> {
  yield fork(function* () {
    yield takeLatest(UserActionType.FETCH_USER_INFO_SUCCESS, userInfoSuccess);
  });
}
